import { render, staticRenderFns } from "./allowance.vue?vue&type=template&id=376f83e2&"
import script from "./allowance.vue?vue&type=script&lang=js&"
export * from "./allowance.vue?vue&type=script&lang=js&"
import style0 from "./allowance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports